import * as React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

export default function SvgIconChildren(props) {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 512 512"
        strokeWidth="10"
      >
        <path
          d="M109.5 1.5C86.5 5.1 68 13.2 49.4 27.6 25.3 46.3 8.5 73.8 2.3 104.8c-2.4 12-2.4 36.6 0 48.2 4.1 19.4 12 37.5 23 52.4 3.9 5.3 31.4 33.6 79.6 81.8 65.8 65.9 74 73.8 77.9 74.8 11.2 2.9 21.8-7.1 19.6-18.8-.6-3.2-9.8-12.8-74.6-78.2-78.5-79-81.2-82.1-88-98-15.4-36.7-7.3-78.6 20.7-106.5C72.9 48 88.7 39 105.6 34.8c12.6-3.1 33.2-3.1 45.8 0 9.9 2.5 22.5 8 31.3 13.8 3.2 2.1 15.5 13.4 27.3 25 24 23.6 26 24.9 34.3 22.4 3.4-1 8.1-5 25.7-22.4 11.8-11.6 24.1-22.9 27.3-25 8.5-5.5 21-11.1 30.7-13.7 12.2-3.2 33.7-3.3 46.4-.1 34.8 8.7 61.1 35.1 70.8 71 3.1 11.4 3.1 33.4 0 45.5-3 11.9-7.2 21.5-13.9 31.6-6.9 10.3-7.9 16-4.1 22.5 4.2 7.2 14.5 9.9 21.5 5.6 6.9-4.2 18.6-23.8 24.2-40.6 5.1-15.2 6.5-24.4 6.5-40.9.1-16.7-1.2-25.5-5.6-39.5-23.3-73.9-106.1-110.5-176.4-78-14.6 6.7-24.6 14.2-41.6 30.9L240 58.3l-15.7-15.4c-16.9-16.6-27-24.1-41.4-30.8-22-10.3-50-14.4-73.4-10.6z"
          stroke="currentColor"
        />
        <path
          d="M351 236.4c-60.7 10.8-106.5 58-115.1 118.5-1.5 10.6-.7 36.1 1.5 46.1 5.8 26.5 17.9 49.2 36.7 68.5 20.1 20.7 43.1 33.4 71.7 39.7 14.5 3.2 40.7 3.2 55.1 0 28.5-6.4 50.2-18.2 70.2-38.1 19.9-20 31.7-41.7 38.1-70.2 3.2-14.4 3.2-40.6 0-55.1-4.3-19.8-12.4-38.1-23.9-53.9-7.1-9.9-24.4-26.8-34.1-33.2-14.8-9.9-32.1-17.3-49.7-21.2-9.7-2.2-40.5-2.9-50.5-1.1zm41.3 32.1c37.3 6.5 69 33.6 81.6 69.9 11.7 33.3 5.7 70.9-15.7 99.2-33.7 44.6-96.6 55.5-143.4 24.7-24.1-15.8-41.4-42.1-46.3-70-10.1-57.8 27.4-112.3 85.1-123.7 9.3-1.9 28.3-1.9 38.7-.1z"
          stroke="currentColor"
        />
        <path
          d="M365 301.2c-1.9 1.3-4.5 4.3-5.7 6.8-2.3 4.4-2.3 4.9-2.3 44.9v40.6l-9.3-9.3c-10.3-10.3-13.8-12-20.6-10.2-9.8 2.6-14.6 12.1-11 21.7 1.4 3.7 45.4 47.9 50.1 50.4 4.4 2.3 8.7 2.4 13.1.5 4.1-1.8 50.3-48.2 51.7-51.9 1.5-4.2 1.2-8.3-1-12.7-2.3-4.5-5-6.7-10.2-8.1-6.9-1.8-11.2.2-21.5 10.4l-9.3 9.1v-41.3c0-45.6 0-45.9-6.3-50.3-4.7-3.4-13.2-3.6-17.7-.6z"
          stroke="currentColor"
        />
      </svg>
    </SvgIcon>
  )
}
